import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { getActiveTimer } from '../../lib/stores/session.svelte.ts';
import { getActiveChildren, getChildById } from '../../lib/stores/children.svelte.ts';
import { navigate } from '../../lib/router.svelte.ts';
import Timer from './Timer.svelte';

var root_1 = $.from_html(`<button class="active-banner svelte-slmdotw789n6"><div class="banner-left svelte-slmdotw789n6"><div class="banner-dot svelte-slmdotw789n6"></div> <span class="banner-type svelte-slmdotw789n6"> <!> <!></span></div> <!></button>`);

function ActiveBanner($$anchor, $$props) {
	$.push($$props, true);

	const timer = $.derived(getActiveTimer);
	const showChildName = $.derived(() => getActiveChildren().length > 1);
	const childName = $.derived(() => $.get(timer) ? getChildById($.get(timer).childId)?.name : undefined);
	var fragment = $.comment();
	var node = $.first_child(fragment);

	{
		var consequent_2 = ($$anchor) => {
			var button = root_1();
			var div = $.child(button);
			var span = $.sibling($.child(div), 2);
			var text = $.child(span);
			var node_1 = $.sibling(text);

			{
				var consequent = ($$anchor) => {
					var text_1 = $.text();

					$.template_effect(() => $.set_text(text_1, `· ${$.get(timer).side ?? ''}`));
					$.append($$anchor, text_1);
				};

				$.if(node_1, ($$render) => {
					if ($.get(timer).side) $$render(consequent);
				});
			}

			var node_2 = $.sibling(node_1, 2);

			{
				var consequent_1 = ($$anchor) => {
					var text_2 = $.text();

					$.template_effect(() => $.set_text(text_2, `· ${$.get(childName) ?? ''}`));
					$.append($$anchor, text_2);
				};

				$.if(node_2, ($$render) => {
					if ($.get(showChildName) && $.get(childName)) $$render(consequent_1);
				});
			}

			$.reset(span);
			$.reset(div);

			var node_3 = $.sibling(div, 2);

			Timer(node_3, {
				get startTime() {
					return $.get(timer).startTime;
				},
				size: 'sm'
			});

			$.reset(button);
			$.template_effect(() => $.set_text(text, `${$.get(timer).sessionType === 'nursing' ? 'Nursing' : 'Pumping'} `));
			$.delegated('click', button, () => navigate(`/session/${$.get(timer).sessionType}`));
			$.append($$anchor, button);
		};

		$.if(node, ($$render) => {
			if ($.get(timer)) $$render(consequent_2);
		});
	}

	$.append($$anchor, fragment);
	$.pop();
}

if (import.meta.hot) {
	ActiveBanner = $.hmr(ActiveBanner);

	import.meta.hot.accept((module) => {
		$.cleanup_styles('svelte-slmdotw789n6');
		ActiveBanner[$.HMR].update(module.default);
	});
}

export default ActiveBanner;

$.delegate(['click']);
import "bun-svelte:ActiveBanner.svelte-1eebq9vcnsnge-style.css";